import { render, staticRenderFns } from "./no-data.component.vue?vue&type=template&id=6eb6cc56&scoped=true"
import script from "./no-data.component.vue?vue&type=script&lang=ts"
export * from "./no-data.component.vue?vue&type=script&lang=ts"
import style0 from "./no-data.component.vue?vue&type=style&index=0&id=6eb6cc56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb6cc56",
  null
  
)

export default component.exports